import type { TooltipProps } from 'recharts';

interface ChartTooltipProps extends TooltipProps<number, string> {
  /** Formats the value, e.g. as money. Defaults to the raw number. */
  formatValue?: (value: number) => string;
}

/**
 * One tooltip shape for every chart. Values wear text tokens rather than the
 * series colour; the colour swatch beside the label carries identity.
 */
export function ChartTooltip({ active, payload, label, formatValue }: ChartTooltipProps) {
  if (!active || !payload?.length) {
    return null;
  }

  return (
    <div className="rounded-lg border border-slate-200 bg-white px-3 py-2 shadow-lg">
      {label !== undefined && (
        <p className="mb-1 text-xs font-medium text-slate-500">{String(label)}</p>
      )}

      {payload.map((entry) => (
        <div key={String(entry.dataKey)} className="flex items-center gap-2 text-sm">
          <span
            aria-hidden
            className="h-2 w-2 shrink-0 rounded-full"
            style={{ backgroundColor: entry.color }}
          />
          <span className="text-slate-900">
            <span className="font-semibold tabular-nums">
              {formatValue && typeof entry.value === 'number'
                ? formatValue(entry.value)
                : entry.value}
            </span>{' '}
            <span className="text-slate-500">{entry.name}</span>
          </span>
        </div>
      ))}
    </div>
  );
}
